import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { userHasRight } from "selectors/rights";
import { FIELDREPPROFILE_EDIT } from "typeConstants/rights";
import { MCard } from "components/Shared";
import { getAllServiceRegions } from "actions/region";
import { ServiceTypeEnum } from "typeConstants/ServiceTypeEnum";
import RegionManagementPane from "components/InspectorRegionManager/RegionManagementPane.tsx";

const FieldRepServiceRegion = ({
  cellWidth,
  fieldRep,
  canEdit,
  onEditClicked,
  isEditing,
}) => {

  return (
    <MCard
        key={isEditing ? "editing-fr-regions" : "viewing-fr-regions"}
        className="mcard-mgrid-250"
        title="Field Rep Coverage"
        cellWidth={cellWidth || 12}
        isEditable={canEdit}
        onEditStarted={onEditClicked}
      >
        <RegionManagementPane inspectorNumberForViewOnly={fieldRep.inspectorLocation.inspectorNumber} />
      </MCard>
  );
};

FieldRepServiceRegion.propTypes = {
  cellWidth: PropTypes.number,
  onEditClicked: PropTypes.func,
  isEditing: PropTypes.bool,

  // redux state
  fieldRep: PropTypes.object.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

const mapStateToProps = state => {
  return {
    fieldRep: state.assignment.inspectorDetails,
    canEdit: userHasRight(FIELDREPPROFILE_EDIT)(state),
  };
};

const mapDispatchToProps = dispatch => ({
  getAllServiceRegions() {
    dispatch(getAllServiceRegions(ServiceTypeEnum.Inspector));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FieldRepServiceRegion);
